export interface User {
  uuid: string;
  nombre: string;
  apellido: string;
  email: string;
  rol?: string;
  imagen?: string;
  token?: string;
  refreshToken?: string;
  activo: boolean;
}

export enum Roles {
  admin = "ADMIN",
  user = "USER",
  specialist = "ESPECIALISTA",
}